import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { filter, Observable, Subscription } from "rxjs";
import { EnumLayerSources } from "src/app/features/shared/helpers/enums/EnumLayerSources";
import { MAP_BUILD_NAMES, MAP_MODULE_NAMES } from "src/models/common/EnumMapas";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ToolCarsSelectorService } from "src/app/features/pages/maps/services/Tool-Cars-Selector.service";
import { MapHelperService } from "src/services/map-helper.service";
import { LayerDTO } from "../../../../models/LayerDTO";
import { LayerService } from "../../../../services/Layers.service";
import { PanelExternalLayerService } from "../../../../services/Panel-External-Layer.service";
@Component({
  selector: "panel-external-layers",
  templateUrl: "./panel-external-layers.component.html",
  styleUrls: ["./panel-external-layers.component.css"],
  animations: [
    trigger("mostrarLista", [
      state("visible", style({ opacity: 1, height: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
    trigger("expandCollapseLayers", [
      state("expanded", style({ opacity: 1, height: "*" })),
      state("collapsed", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("expanded <=> collapsed", animate("350ms ease-in-out")),
    ]),
  ],
})
export class PanelExternalLayersComponent implements OnInit, OnDestroy {
  isInitializingLayers: boolean = false;
  listaCapasVisible: boolean = false;

  //Array con las posibles opcciones.
  //Si se ocupa hacerlo dinámico con los add-ons después, se puede
  $capas = new Array<LayerDTO>();
  suscription_GetListLayers: Subscription;
  suscription_GetLayerDataByNameGeoJSON: Subscription;
  // $capas = [
  //   { label: 'Geocercas', checked: false, capaId: "" } /*"layer-geofencesPolygons" este es el id que trataba de poner para manipularla en el map helper*/
  // ];

  $capasService: Observable<any>;
  subscription_GetGeofenceIndicator: Subscription;
  Subscription_GetMapMainSource: Subscription;

  constructor(
    private mapHelper: MapHelperService,
    public panelExternalLayerService: PanelExternalLayerService,
    public layerCatalogService: LayerService,
    public toolCarsSelectorService: ToolCarsSelectorService,
  ) {
    this.$capasService = this.panelExternalLayerService.getLayers();
    this.subscription_GetGeofenceIndicator = this.$capasService.subscribe((data)=>{
      this.$capas = data;
    });
  }

  ngOnInit(): void {
    this.Subscription_GetMapMainSource = this.mapHelper.mainSource$.pipe(
      filter(location => location && location.isMainSourceReady && location.isStyleReady)
    ).subscribe(location => {
      if (location && location.isMainSourceReady && location.isStyleReady && !this.isInitializingLayers) {
        if (location.loadedMapName.includes(MAP_BUILD_NAMES.GPS) || location.loadedMapName.includes(MAP_BUILD_NAMES.Unilever)) {
          this.GetListLayers();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
    if (this.suscription_GetLayerDataByNameGeoJSON)
      this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
    if (this.subscription_GetGeofenceIndicator)
      this.subscription_GetGeofenceIndicator.unsubscribe();
    if (this.Subscription_GetMapMainSource)
      this.Subscription_GetMapMainSource.unsubscribe();
  }

  GetListLayers() {
    this.isInitializingLayers = true;
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
    this.suscription_GetListLayers = this.layerCatalogService.GetListLayers(EnumLayerSources.External).subscribe({
      next: (data) => {
        this.$capas = data.result as LayerDTO[];
        if (this.$capas != null && this.$capas.length != 0) {
          this.panelExternalLayerService.capas = this.$capas;
          this.$capas.slice().reverse().forEach((element) => {
            this.panelExternalLayerService.createMapLayer(element);
          });
          this.mapHelper.CreateExternalLayersHoverEvent(this.$capas);
          
          this.layerCatalogService.isExternalLayersButtonDisabled = false;
        }else{
          this.panelExternalLayerService.capas = [];
          this.layerCatalogService.isExternalLayersButtonDisabled = true;
        }
        this.isInitializingLayers = false;
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener lista de capas externas', error);
        this.isInitializingLayers = false;
      }
    });
  }

  onClickListaCapas() {
    this.toolCarsSelectorService.isCarSelectionToolVisible = false;
    this.layerCatalogService.isInternalLayersVisible = false;
    this.layerCatalogService.isMapLayersVisible = false;
    this.layerCatalogService.isGeneralManagementVisible = false;
    this.layerCatalogService.isExternalLayersVisible = !this.layerCatalogService.isExternalLayersVisible;
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(nameLayer: any) {
    const layer = this.$capas.find(c => c.name === nameLayer);
    if(layer.checked)
      return;
    
    this.panelExternalLayerService.onToggleLayer(nameLayer);
  }

  ClosePanel() {
    this.layerCatalogService.isExternalLayersVisible = false;
  }

  toggleExternalLayers() {
    this.panelExternalLayerService.isExternalLayersExpanded = !this.panelExternalLayerService.isExternalLayersExpanded;
  }

  onExpandCollapseStart(event: any) {
    this.panelExternalLayerService.isExpandCollapseAnimating = true;
  }

  onExpandCollapseDone(event: any) {
    this.panelExternalLayerService.isExpandCollapseAnimating = false;
  }

  onDropLayer(event: CdkDragDrop<any[]>) {
    console.log("capas", event);
    console.log("capas 1", this.$capas);
    moveItemInArray(this.$capas, event.previousIndex, event.currentIndex);
    console.log("capas 2", this.$capas);
    this.panelExternalLayerService.capas = this.$capas;
    var layerNames = this.panelExternalLayerService.getLayerNames(this.$capas);
    console.log("capas nombre", layerNames);
    
    this.mapHelper.layerReorganizationFirstIsLast(layerNames);
  }

  async onRestartLayer(layer: LayerDTO) {
    if (!layer.checked) return;
    this.panelExternalLayerService.DeactivateLayer(layer.name);
    await new Promise(resolve => setTimeout(resolve, 500));
    this.panelExternalLayerService.ActivateLayer(layer.name);
  }

}
